import moment from "moment";
import React, { Component } from "react";
import Modal from "react-modal";
import Loader from "react-loader";
import styles from "./CurrentProjects.module.css";
import { getCurrentTerm, getCurrentYear, getYearByCourse } from "../../utils/getItemFromRange";

import SelectField from "../shared/SelectField";
import * as _ from "lodash";
import { formValueSelector, reduxForm, getFormValues } from "redux-form";
import { connect } from 'react-redux';
import {
  transformCourses,
  transformTerms,
  transformYears,
  transformStudents,
  transformCourses_course,
} from "../../utils/const";
import StudentProject from "./StudentProject";
import DatePickerField from "../shared/DatePickerField";
// import { fetchDisciplinesByParams } from "../../actions/discipline";



const selector = formValueSelector("studentProjects");

const TYPE_WORKS = [
  { name: "Курсовые работы (проекты, задачи)", value: 1 },
  { name: "Лабораторные и расчетно-графические работы", value: 2 },
  { name: "Письменные отчеты о выполнении программ практик и индивидуальных заданий", value: 3 },
  { name: "Выпускная квалификационная работа", value: 4 },
];

const STATUSES = [
  { name: "Черновик", value: 0 },
  { name: "Выдано", value: 1 },
  { name: "Новое", value: 2 },
  { name: "Выполнено", value: 3 },
  { name: "Закрыто", value: 4 },
];

class CurrentProjects extends Component {
  state = {
    tabIndex: 0,
    isModalVisible: false,
    modalTarget: null,
    type: null,
    row: null,
    isLoading: false,
    selectedProject: {},
  };

  _disciplinesFetchTimer = null;

  componentDidMount() {

    const { years, terms, initialize, mid, fetchTerms } = this.props;
    const {
      fetchAllDisciplines,
      fetchDisciplinesByParams,
      fetchYears,
      fetchStudents,
      getStudentsList,
      getCoursesList,
      fetchGroupList,
      // getGroupList,
      course,
      fetchDisciplinesByTerm,
    } = this.props;
    // fetchDisciplinesByParams()
    // fetchAllDisciplines();
    fetchYears();
    // fetchGroupList(); /// ВСЕ ГРУППЫ 
    // getGroupList()
    getCoursesList();
    this.isTeacher() && fetchStudents('teacher'); // TODO  КАК РАБОТАТЬ СО СТУДЕНТАМИ??
    this.isTeacher() && fetchGroupList();

    initialize({
      termId: (terms && terms.length) ? getCurrentTerm(terms).trmid : null,
      yearId: (years && years.length) ? getCurrentYear(years).xp_key : null,
      subjectId: 0,
      studentId: this.isTeacher() ? 0 : mid,
    })

    // if (years.length) {
    //   fetchTerms(getCurrentYear(years).xp_key)
    // }
  }
  componentDidUpdate(prevProps) {

    const { myValues, fetchDisciplinesByTerm, isTeacher, getStudentsList, getGroupList, fetchTerms, years, terms, change, fetchDisciplinesByParams, initialize } = this.props;
    const { selectedProject } = this.state;

    const { subjectId, termId, studentId, groupId, yearId, eyId } = myValues;

    // Для студентов используем fetchDisciplinesByTerm (course/student)
    if (!isTeacher && termId && termId !== prevProps.myValues.termId) {
      fetchDisciplinesByTerm(termId)
    }

    if (prevProps.coursesList !== this.props.coursesList) {
      change('eyId', '0')
    }

    if (yearId && eyId && (eyId !== prevProps.myValues.eyId || yearId !== prevProps.myValues.yearId)) {
      getGroupList(yearId, eyId)
    }

    if (yearId && termId && groupId && groupId !== prevProps.myValues.groupId) {
      const selectedTerm = terms.find(el => el.trmid === +termId)
      getStudentsList({ ...myValues, begdate: selectedTerm.term_begin, enddate: selectedTerm.term_end })
    }

    // Для преподавателя: вызываем students_projects/course при изменении любого фильтра (debounce — один вызов)
    if (isTeacher && (
      yearId !== prevProps.myValues.yearId ||
      termId !== prevProps.myValues.termId ||
      eyId !== prevProps.myValues.eyId ||
      groupId !== prevProps.myValues.groupId
    )) {
      clearTimeout(this._disciplinesFetchTimer);
      this._disciplinesFetchTimer = setTimeout(() => {
        fetchDisciplinesByParams({ xp_key: yearId, trmid: termId, eyid: eyId, gid: groupId });
      }, 300);
    }

    if (terms?.length && terms !== prevProps.terms) {
  initialize({
    ...myValues,
    termId: terms[0]?.trmid || '0', // выбираем первое значение
  });
}
  }


  componentWillReceiveProps(nextProps) {

    const { myValues, terms, initialize, fetchTerms, years, course, mid } = this.props;
    const { yearId, termId } = myValues;


    nextProps.studentProjects && this.setState({ isLoading: false });

    if (!years.length && nextProps.years.length) {
      fetchTerms(getCurrentYear(nextProps.years).xp_key)
    }

    if (!terms.length && nextProps.terms.length) {
      initialize({
        termId: getCurrentTerm(nextProps.terms)?.trmid,
        yearId: getCurrentYear(nextProps.years)?.xp_key,
        subjectId: 0,
        studentId: this.isTeacher() ? 0 : mid,
        eyId: nextProps.myValues.eyId,
      })
    }
    if (!years.length && nextProps.years.length) {
      initialize({
        // termId: getCurrentTerm(nextProps.terms)?.trmid,
        yearId: getCurrentYear(nextProps.years)?.xp_key,
        subjectId: 0,
        studentId: this.isTeacher() ? 0 : mid,
        eyId: nextProps.myValues.eyId,
      })
    }

    if (!_.isEmpty(myValues, true)) {
      if (yearId !== nextProps.myValues.yearId) {
        const yearId = nextProps.myValues.yearId;
        nextProps.fetchTerms(yearId);
        // nextProps.fetchAllDisciplines();
      }
      if (!_.isEqual(terms, nextProps.terms)) {
        initialize({
          yearId: nextProps.myValues.yearId,
          termId: nextProps.myValues.trmid,
          // termId: getCurrentTerm(nextProps.terms)?.trmid,
          subjectId: nextProps.myValues.subjectId,
          studentId: nextProps.myValues.studentId || 0,
          eyId: nextProps.myValues.eyId,

        });
      }
    }

    if (myValues.eyId !== nextProps.myValues.eyId && years.length) {
      initialize({
        yearId: nextProps.myValues.yearId || getYearByCourse(course, nextProps.myValues.eyId, years)?.xp_key,
        termId: nextProps.myValues.termId || nextProps.terms[0]?.trmid,
        subjectId: nextProps.myValues.subjectId,
        studentId: nextProps.myValues.studentId || 0,
        groupId: nextProps.myValues.groupId,
        eyId: nextProps.myValues.eyId
      })
    }

    if (myValues.groupId !== nextProps.myValues.groupId) {
      const groupId = nextProps.myValues.groupId
      // this.props.fetchStudents(null, groupId)
    }

  }

  componentWillUnmount() {
    clearTimeout(this._disciplinesFetchTimer);
  }

  isTeacher = () => this.props.history.location.pathname === "/student_projects_teacher";

  fetchStudentProjects = () => {
    const { fetchStudentProjects, myValues } = this.props;
    const { subjectId, termId, studentId, groupId } = myValues;

    fetchStudentProjects(subjectId, termId, this.props.isTeacher, studentId, groupId || 0);
    this.setState({ isLoading: true });
  };

  handleToggleModal = (isModalVisible, row, files, id, values, setStatus) => () => {
    // console.log('values::: ', values);
    
    if (!isModalVisible) {
      if (id) {
        if (values && values.task) {
          let obj = {
            task: values.task,
          };
          if (values.result) {
            // console.log('values.result::: ', values.result);
            obj.result = values.result
            obj.status = !!setStatus ? 0 : 3;
            // obj.status = 3;
          }
          if (values.hasOwnProperty("grade") && values.grade !== undefined) {
            obj.grade = values.grade ? Number(values.grade) : null; // '' ("не указано") → null для очистки оценки; бэк принимает grade только как null или число
            if (values.grade) {
              obj.status = 4;
            }
          }
          this.props.updateStudentWork(id, obj);
          // console.log('obj::: ', obj);
        }
      } else {
        if (values && values.task) {
          const { formValues, myValues, disciplines, disciplinesByTerms } = this.props;
          this.props.addProject({
            grade: values.grade ? Number(values.grade) : null,
            issuedate: moment().format("YYYY-MM-DD"),
            status: 1,
            task: values.task,
            cid: formValues.subjectId || disciplinesByTerms[0].cid,
            type: (formValues && formValues.type) || TYPE_WORKS[0].value,
            student: formValues && formValues.studentId,
            duedate:
              formValues && moment(formValues.duedate).format("YYYY-MM-DD"),
            // file:
            //   values && values.file && !!values.file.length && values.file,
            termId: myValues && myValues.termId,
            groupId: myValues && myValues.groupId
          }, files);
        }
      }
      this.props.clearProject();
    }
    row && isModalVisible && this.props.fetchStudentProject(row.xp_key);
    !isModalVisible && this.setState({ selectedProject: {} });
    this.setState(
      { isModalVisible, newProject: false },
      this.fetchStudentProjects
    );
  };

  renderRow = (row, index) => {
    return (
      <tr key={index} onClick={this.handleToggleModal(true, row)}>
        {this.isTeacher() && (
          <td className="td-center">{row.studentname || "не указано"}</td>
        )}
        <td className="td-center">
          {(row.type && TYPE_WORKS[Number(row.type) - 1]) ? TYPE_WORKS[Number(row.type) - 1]?.name : "не указано"}
        </td>
        <td className="td-center">{row.coursetitle || "не указано"}</td>
        <td className="td-center">
          {moment(row.issuedate).format("DD.MM.YYYY")}
        </td>
        <td className="td-center">
          {moment(row.duedate).format("DD.MM.YYYY")}
        </td>
        <td className="td-center">
          {(STATUSES.find(stat => stat.value === row.status)?.name) || "не указано"}
        </td>
        <td className="td-center">{row.grade || "не указано"}</td>
      </tr>
    );
  };

  addProject = (isModalVisible, row, files, id, setStatus) => (values) => {
    // console.log('isModalVisible, row, files, id, newProject::: ', isModalVisible, row, files, id, setStatus);
    if (values && values.task) {
      this.handleToggleModal(isModalVisible, row, files, id, values, setStatus)();
    }
  };
  // updateProject = (isModalVisible, row, files, id, ) => (values) => {
  //   if (values && values.task ) {
  //     this.handleToggleModal(isModalVisible, row, files, id, values)();
  //   }
  // };

  addProjectModal = () => {
    this.setState({ isModalVisible: true, newProject: true });
  };
  render() {
    const {
      isTeacher,
      years,
      terms,
      disciplines,
      disciplinesByTerm,
      disciplinesByTerms,
      students, // ПЕРЕДЕЛАл
      studentList,
      studentProjects,
      uploadFile,
      deleteFile,
      downloadFile,
      selectedProject,
      uploadReviewFile,
      addReview,
      coursesList,
      course,
      group,
      myValues,
    } = this.props;

    const { subjectId, termId, studentId, groupId } = myValues;
    const { isModalVisible, newProject, formValues } = this.state;

    return (
      <div className="uspex 23.jpg jpg23">
        <Modal
          isOpen={isModalVisible}
          onRequestClose={this.handleToggleModal(false, {})}
          contentLabel="Modal"
        >
          <div className="PR-StudProjModal">
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div className="PR-StudProjModal__header">
                <p>
                  <span>Вид работы:</span>
                  {newProject ? (
                    <SelectField
                      className="schedule__select"
                      name="type"
                      options={TYPE_WORKS}
                    />
                  ) : (
                    selectedProject && (TYPE_WORKS.find(el => el.value == selectedProject.type)?.name || "не указано")
                  )}
                </p>
                <p>
                  <span>Дисциплина:</span>
                  {newProject ? (
                    <SelectField
                      defaultValue={disciplinesByTerms?.[0]?.cid}
                      className="schedule__select"
                      name="subjectId"
                      options={transformCourses(disciplinesByTerms)}
                    />
                  ) : (
                    selectedProject &&
                    (selectedProject.coursetitle || "не указано")
                  )}
                </p>
                <p>
                  <span>Обучающийся:</span>
                  {newProject ? (
                    <SelectField
                      className="schedule__select"
                      name="studentId"
                      // options={transformStudents(students)}
                      options={transformStudents(studentList)}
                    />
                  ) : (
                    selectedProject &&
                    (selectedProject.studentname || "не указано")
                  )}
                </p>
                <p>
                  <span>Срок выполнения:</span>
                  {newProject ? (
                    <input 
                      type="date" 
                      name="duedate" 
                      className="schedule__selectdate"
                      defaultValue={moment().format('YYYY-MM-DD')}
                      onChange={this.handleChange}
                    />

                  ) : (
                    selectedProject &&
                    moment(selectedProject.duedate).format("DD.MM.YYYY")
                  )}
                </p>
              </div>
              <div className="PR-StudProjModal__header">
                <p>
                  <span>Статус: </span>
                  {selectedProject && STATUSES[selectedProject.status]?.name}
                </p>
                <p>
                  <span>Дата выдачи: </span>
                  {selectedProject && moment(selectedProject.issuedate).format("DD.MM.YYYY")}
                </p>
              </div>
            </div>

            <div className="PR-StudProjModalTab">
              <StudentProject
                {...selectedProject}
                uploadFile={uploadFile}
                deleteFile={deleteFile}
                downloadFile={downloadFile}
                uploadReviewFile={uploadReviewFile}
                addReview={addReview}
                removeReview={this.props.removeReview}
                isTeacher={this.props.isTeacher}
                mid={this.props.mid}
                editReview={this.props.editReview}
                removeReviewFile={this.props.removeReviewFile}
                selectedProject={selectedProject}
                handleToggleModal={this.handleToggleModal}
                addProject={this.addProject}
              />
            </div>
          </div>
        </Modal>

        <div className="captions">Работы/проекты обучающегося</div>
        <div>
          <div>
            <div className="selectors pos-rel">
              <div className={styles.selectorWrapper}>
                <div className={styles.inputLabel}>Год:</div>
                <div className="inputs__input inputs__input_schedule_small">
                  <SelectField
                    className="schedule__select"
                    name="yearId"
                    defaultValue={years.length && getCurrentYear(years).xp_key}
                    options={transformYears(years)?.reverse()}
                  />
                </div>
              </div>
              <div className={styles.selectorWrapper}>
                <div className={styles.inputLabel}>Семестр:</div>
                <div className="inputs__input inputs__input_schedule_small">
                  <SelectField
                    className="schedule__select"
                    name="termId"
                    defaultValue={myValues.termId}
                    // defaultValue={terms.length && getCurrentTerm(terms).trmid}
                    options={transformTerms(terms)}
                  />
                </div>
              </div>

              {!this.isTeacher() && <div className="inputs__input inputs__input_schedule_small">
                    <div className={styles.inputLabel}>Дисциплина:</div>
                    <SelectField
                      className="schedule__select"
                      name="subjectId"
                      options={[
                        { name: "Все", value: '0' },
                        ...transformCourses_course(disciplinesByTerm),
                      ]}
                    />
                  </div>}

                {this.isTeacher() && (
              <div className={styles.selectorWrapper}>
                <div className={styles.inputLabel}>Курс:</div>
                <div className="inputs__input inputs__input_schedule_small">
                  <SelectField
                    className="schedule__select"
                    name="eyId"
                    defaultValue={0}
                    options={[{ name: "Все", value: '0' }, ...coursesList].map(it => ({ value: it.eyid, name: it.name }))}
                  />
              </div>
                </div>
                )}
                
              <div className={styles.selectorWrapper}>
                {this.isTeacher() && (
                  <div className={styles.selectorWrapper}>

                    <div className={styles.inputLabel}>Группа:</div>
                    <div className="inputs__input inputs__input_schedule_small">
                      <SelectField
                        className="schedule__select"
                        defaultValue={"0"}
                        name="groupId"
                        options={group && [
                          { name: "Все", value: '0' },
                          ...group.map(it => ({ name: it.name, value: it.gid }))
                        ]}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>


          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
            <div className="selector" style={{ display: 'flex', justifyContent: 'space-around', width: '50%' }}>
                {isTeacher ?
                  <div className="inputs__input inputs__input_schedule_small">
                    <div className={styles.inputLabel}>Дисциплина:</div>        
                    <SelectField
                      className="schedule__select"
                      name="subjectId"
                      options={[
                        { name: "Все", value: '0' },
                        // ...transformCourses(disciplinesByTerms),
                        ...disciplinesByTerms.map(it => ({ name: it.title, value: it.cid }))
                      ]}
                    />
                  </div>
                  :
                    <></>
                }
              
              {this.isTeacher() && (
                <div className={styles.selectorWrapper}>
                  <div className={styles.inputLabel}>Обучающийся:</div>
                  <div className="inputs__input inputs__input_schedule_small">
                    <SelectField
                      className="schedule__select"
                      defaultValue={"0"}
                      name="studentId"
                      options={studentList && [
                        { name: "Все", value: '0' },
                        // ...transformStudents(students),
                        ...transformStudents(studentList),
                      ]}
                    />

                  </div>
                </div>
              )}

            </div>
            <div>
              <button className={!termId ? styles.updateDisabled : styles.update} disabled={!termId} onClick={this.fetchStudentProjects}>
                Обновить
              </button>
              {isTeacher && (
                <button className={!groupId ? styles.updateDisabled : styles.update} disabled={!groupId} onClick={this.addProjectModal}>
                  Добавить
                </button>
              )}
            </div>
          </div>

        </div>
        <Loader loaded color="#7b2b2a">
          {studentProjects.length >= 1 && (
            <div className="work-project">
              <table >
                <thead>
                  <tr>
                    {this.isTeacher() && (
                      <th className="table-title" width="15%">
                        Обучающийся
                      </th>
                    )}
                    {/*<th className="table-title" width="25%">Вид работы</th>*/}
                    <th
                      className="table-title"
                      width={this.isTeacher() ? "10%" : "25%"}
                    >
                      Вид работы
                    </th>
                    <th className="table-title" width="25%">
                      Дисциплина
                    </th>
                    <th className="table-title" width="10%">
                      Дата выдачи
                    </th>
                    <th className="table-title" width="10%">
                      Срок выполнения
                    </th>
                    <th className="table-title" width="15%">
                      Статус
                    </th>
                    <th className="table-title" width="10%">
                      Оценка
                    </th>
                  </tr>
                </thead>
                <tbody>{studentProjects.map(this.renderRow)}</tbody>
              </table>
            </div>
          )}
          <div style={{ textAlign: "center", marginTop: '150px' }}>
            {studentProjects.length === 0 && (
              <h5>По заданным параметрам ничего не найдено.</h5>
            )}
          </div>
        </Loader>
      </div>
    );
  }
}

const StudentProjectsForm = reduxForm({
  form: "studentProjects",
  enableReinitialize: true,
})(CurrentProjects);

export default connect((state) => (
  {
    myValues: selector(
      state,
      "yearId",
      "termId",
      "subjectId",
      "studentId",
      "groupId",
      "eyId",
      "file",
      "filename"
    ),
    formValues: getFormValues("studentProjects")(state),
  }))(StudentProjectsForm);
